import { isAxiosError } from 'axios';
import HttpClient from '../HttpClient';
import HTTPResponse from '../HttpResponse';

class Status {
  private http: HttpClient;

  public constructor(http: HttpClient) {
    this.http = http;
  }

  public getStatus = async (): Promise<HTTPResponse<object>> => {
    let res;
    try {
      const result = await this.http.get('/greeting');
      res = result.data;
      return new HTTPResponse(res);
    } catch (err) {
      if (isAxiosError(err)) {
        const { response } = err;
        return new HTTPResponse(res, response);
      }
      return new HTTPResponse([]);
    }
  };
}

export default Status;
